const FREE_SHIPPING_METER_VALUE_KEY = 'ps_free_shipping_meter';
const FREE_SHIPPING_METER_LOCKED_KEY = 'ps_free_shipping_meter_locked';

const NULL_SENTINEL = 'null';

export function getStoredFreeShippingMeterValue(): string | null {
    if (globalThis.window === undefined) {
        return null;
    }

    const stored = sessionStorage.getItem(FREE_SHIPPING_METER_VALUE_KEY);
    if (stored === null || stored === NULL_SENTINEL) {
        return null;
    }

    return stored;
}

export function setStoredFreeShippingMeterValue(value: string | null): void {
    if (globalThis.window === undefined) {
        return;
    }

    sessionStorage.setItem(FREE_SHIPPING_METER_VALUE_KEY, value ?? NULL_SENTINEL);
}

export function isFreeShippingMeterLockedForConfirmation(): boolean {
    if (globalThis.window === undefined) {
        return false;
    }

    return sessionStorage.getItem(FREE_SHIPPING_METER_LOCKED_KEY) === 'true';
}

/** Locks the current stored meter value so an emptied cart cannot overwrite purchase-time state. */
export function lockFreeShippingMeterForOrderConfirmation(): void {
    if (globalThis.window === undefined) {
        return;
    }

    sessionStorage.setItem(FREE_SHIPPING_METER_LOCKED_KEY, 'true');
}

/** Releases the confirmation lock while keeping the stored value for re-reads until the next sync. */
export function unlockFreeShippingMeterForOrderConfirmation(): void {
    if (globalThis.window === undefined) {
        return;
    }

    sessionStorage.removeItem(FREE_SHIPPING_METER_LOCKED_KEY);
}

export function clearFreeShippingMeterStorage(): void {
    if (globalThis.window === undefined) {
        return;
    }

    sessionStorage.removeItem(FREE_SHIPPING_METER_VALUE_KEY);
    sessionStorage.removeItem(FREE_SHIPPING_METER_LOCKED_KEY);
}

export function syncFreeShippingMeterStorage(value: string | null): void {
    if (isFreeShippingMeterLockedForConfirmation()) {
        return;
    }

    setStoredFreeShippingMeterValue(value);
}
